import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button, Dropdown } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaHome, FaBox, FaIndustry, FaMoneyBill, FaChartBar, FaUsers, FaUserCircle, FaSignOutAlt, FaFileInvoice } from 'react-icons/fa';

const CustomNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userRole');
    localStorage.removeItem('user');
    navigate('/login');
  };

  if (location.pathname === '/login' || location.pathname === '/register') {
    return null;
  }

  return (
    <Navbar bg="white" expand="lg" className="shadow-sm" sticky="top">
      <Container>
        <Navbar.Brand as={Link} to="/" className="fw-bold d-flex align-items-center">
          <FaIndustry className="me-2" style={{ color: '#4361ee' }} />
          <span>Order Production System</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" className="d-flex align-items-center">
              <FaHome className="me-1" /> Dashboard
            </Nav.Link>
            <Nav.Link as={Link} to="/orders" className="d-flex align-items-center">
              <FaBox className="me-1" /> Orders
            </Nav.Link>
            <Nav.Link as={Link} to="/production" className="d-flex align-items-center">
              <FaIndustry className="me-1" /> Production
            </Nav.Link>
            <Nav.Link as={Link} to="/expenses" className="d-flex align-items-center">
              <FaMoneyBill className="me-1" /> Expenses
            </Nav.Link>
            <Nav.Link as={Link} to="/billing" className="d-flex align-items-center">
              <FaFileInvoice className="me-1" /> Billing
            </Nav.Link>
            {user?.role === 'admin' && (
            <Nav.Link as={Link} to="/reports" className="d-flex align-items-center">
              <FaChartBar className="me-1" /> Reports
            </Nav.Link>
             )}
            {user?.role === 'admin' && (
              <Nav.Link as={Link} to="/users" className="d-flex align-items-center">
                <FaUsers className="me-1" /> Users
              </Nav.Link>
            )}
          </Nav>
          <Nav>
            {user ? (
              <Dropdown align="end">
                <Dropdown.Toggle variant="light" id="dropdown-user" className="d-flex align-items-center">
                  <FaUserCircle className="me-2" />
                  <div className="text-start">
                    <div className="fw-bold">{user.username}</div>
                    <small className="text-muted">{user.role}</small>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item disabled>
                    <div className="text-muted small">Logged in as</div>
                    <div className="fw-bold">{user.email}</div>
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={handleLogout} className="text-danger">
                    <FaSignOutAlt className="me-2" /> Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Button variant="primary" as={Link} to="/login" className="d-flex align-items-center">
                <FaUserCircle className="me-2" /> Login
              </Button>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
